import { render, staticRenderFns } from "./historyAi.vue?vue&type=template&id=61b84fe0&scoped=true&"
import script from "./historyAi.vue?vue&type=script&lang=js&"
export * from "./historyAi.vue?vue&type=script&lang=js&"
import style0 from "./historyAi.vue?vue&type=style&index=0&id=61b84fe0&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "61b84fe0",
  null
  
)

export default component.exports